import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';


import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LocationStrategy, Location, HashLocationStrategy } from '@angular/common';

//Additional 
//Model
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
//progress bar
import { NgProgressModule } from '@ngx-progressbar/core'
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { NgProgressRouterModule } from '@ngx-progressbar/router';
//Toast Service
import { ToastrModule } from 'ngx-toastr';
//Data Table
import { DataTablesModule } from 'angular-datatables';
// //Select drop down
import { NgSelectModule } from '@ng-select/ng-select';
//Date Pikker
import { BsDatepickerModule } from 'ngx-bootstrap';
//matial input
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';


//Currency
import { CurrencyMaskModule, CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask";
//Ag Grid
import { AgGridModule } from 'ag-grid-angular';
//Sidebar
import { SidebarModule } from 'ng-sidebar';
//Document Viewer
import { NgxDocViewerModule } from 'ngx-doc-viewer';
//Deduct
import { DeviceDetectorModule } from 'ngx-device-detector';
//Search 
import { Ng2SearchPipeModule } from 'ng2-search-filter';
//Session
import { BnNgIdleService } from 'bn-ng-idle';
//Autocomlete
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { NgxMaskModule } from 'ngx-mask'

//PDF 
import { PdfViewerModule } from 'ng2-pdf-viewer';

//Ag Grid
import { NgxPaginationModule } from 'ngx-pagination'; 



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DepartmentComponent } from './components/department/department.component';
import { NavigationComponent } from './navigation/navigation.component';
import { HeaderComponent } from './header/header.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { AdddepartmentComponent } from './components/department/adddepartment/adddepartment.component';
import { TestComponent } from './components/test/test.component';
import { CompanyComponent } from './components/company/company.component';
import { BranchComponent } from './components/branch/branch.component';
import { AllowanceComponent } from './components/allowance/allowance.component';
import { AssettypeComponent } from './components/assettype/assettype.component';
import { BonustypeComponent } from './components/bonustype/bonustype.component';
import { AddbonustypeComponent } from './components/bonustype/addbonustype/addbonustype.component';
import { AddassettypeComponent } from './components/assettype/addassettype/addassettype.component';
import { AddallowanceComponent } from './components/allowance/addallowance/addallowance.component';
import { AddbranchComponent } from './components/branch/addbranch/addbranch.component';
import { AddcompanyComponent } from './components/company/addcompany/addcompany.component';
import { DeductionComponent } from './components/deduction/deduction.component';
import { DesignationComponent } from './components/designation/designation.component';
import { EmptypeComponent } from './components/emptype/emptype.component';
import { ExpensetypeComponent } from './components/expensetype/expensetype.component';
import { GenderComponent } from './components/gender/gender.component';
import { GradeComponent } from './components/grade/grade.component';
import { AdddeductionComponent } from './components/deduction/adddeduction/adddeduction.component';
import { AdddesignationComponent } from './components/designation/adddesignation/adddesignation.component';
import { AddemptypeComponent } from './components/emptype/addemptype/addemptype.component';
import { AddexpensetypeComponent } from './components/expensetype/addexpensetype/addexpensetype.component';
import { AddgenderComponent } from './components/gender/addgender/addgender.component';
import { AddgradeComponent } from './components/grade/addgrade/addgrade.component';
import { IncidenttypeComponent } from './components/incidenttype/incidenttype.component';
import { LeavetypeComponent } from './components/leavetype/leavetype.component';
import { LoantypeComponent } from './components/loantype/loantype.component';
import { LocationComponent } from './components/location/location.component';
import { MaritalstatusComponent } from './components/maritalstatus/maritalstatus.component';
import { MemotypeComponent } from './components/memotype/memotype.component';
import { AddmemotypeComponent } from './components/memotype/addmemotype/addmemotype.component';
import { AddmaritalstatusComponent } from './components/maritalstatus/addmaritalstatus/addmaritalstatus.component';
import { AddlocationComponent } from './components/location/addlocation/addlocation.component';
import { AddloantypeComponent } from './components/loantype/addloantype/addloantype.component';
import { AddleavetypeComponent } from './components/leavetype/addleavetype/addleavetype.component';
import { AddincidenttypeComponent } from './components/incidenttype/addincidenttype/addincidenttype.component';
import { OvertimetypeComponent } from './components/overtimetype/overtimetype.component';
import { AddovertimetypeComponent } from './components/overtimetype/addovertimetype/addovertimetype.component';
import { PaymodeComponent } from './components/paymode/paymode.component';
import { AddpaymodeComponent } from './components/paymode/addpaymode/addpaymode.component';
import { PayrolegrpComponent } from './components/payrolegrp/payrolegrp.component';
import { AddpayrolegrpComponent } from './components/payrolegrp/addpayrolegrp/addpayrolegrp.component';
import { ReimbursetypeComponent } from './components/reimbursetype/reimbursetype.component';
import { AddreimbursetypeComponent } from './components/reimbursetype/addreimbursetype/addreimbursetype.component';
import { RelationshipComponent } from './components/relationship/relationship.component';
import { AddrelationshipComponent } from './components/relationship/addrelationship/addrelationship.component';
import { RelievetypeComponent } from './components/relievetype/relievetype.component';
import { AddrelievetypeComponent } from './components/relievetype/addrelievetype/addrelievetype.component';
import { SkillsComponent } from './components/skills/skills.component';
import { AddskillsComponent } from './components/skills/addskills/addskills.component';
import { UserroleComponent } from './components/userrole/userrole.component';
import { UserComponent } from './components/user/user.component';
import { AssetComponent } from './components/asset/asset.component';
import { HolidaysComponent } from './components/holidays/holidays.component';
import { AdduserroleComponent } from './components/userrole/adduserrole/adduserrole.component';
import { AdduserComponent } from './components/user/adduser/adduser.component';
import { AddassetComponent } from './components/asset/addasset/addasset.component';
import { AddholidaysComponent } from './components/holidays/addholidays/addholidays.component';
import { EmpComponent } from './components/emp/emp.component';
import { AddempComponent } from './components/emp/addemp/addemp.component';
import { DatePipe } from '@angular/common';
import { ExpenseComponent } from './components/expense/expense.component';
import { AddexpenseComponent } from './components/expense/addexpense/addexpense.component';
import { DateFormatPipe } from './date-format.pipe';
import { LeaveComponent } from './components/leave/leave.component';
import { AddleaveComponent } from './components/leave/addleave/addleave.component';
import { IncidentComponent } from './components/incident/incident.component';
import { AddincidentComponent } from './components/incident/addincident/addincident.component';
import { LoginComponent } from './login/login.component';
import { ReligionComponent } from './components/religion/religion.component';
import { SponserComponent } from './components/sponser/sponser.component';
import { ContracttypeComponent } from './components/contracttype/contracttype.component';
import { CategoryComponent } from './components/category/category.component';
import { AddreligionComponent } from './components/religion/addreligion/addreligion.component';
import { AddsponserComponent } from './components/sponser/addsponser/addsponser.component';
import { AddcontracttypeComponent } from './components/contracttype/addcontracttype/addcontracttype.component';
import { AddcategoryComponent } from './components/category/addcategory/addcategory.component';
import { PaytypeComponent } from './components/paytype/paytype.component';
import { WpsgroupComponent } from './components/wpsgroup/wpsgroup.component';
import { BankComponent } from './components/bank/bank.component';
import { AddbankComponent } from './components/bank/addbank/addbank.component';
import { AddwpsgroupComponent } from './components/wpsgroup/addwpsgroup/addwpsgroup.component';
import { AddpaytypeComponent } from './components/paytype/addpaytype/addpaytype.component';
import { StatusComponent } from './components/status/status.component';
import { AddstatusComponent } from './components/status/addstatus/addstatus.component';
import { LeavepolicyComponent } from './components/leavepolicy/leavepolicy.component';
import { AddleavepolicyComponent } from './components/leavepolicy/addleavepolicy/addleavepolicy.component';
import { AccomtypeComponent } from './components/accomtype/accomtype.component';
import { AddaccomtypeComponent } from './components/accomtype/addaccomtype/addaccomtype.component';
import { EmppayComponent } from './components/emppay/emppay.component';
import { PendingChangesGuard } from './components/PendingChangesGuard ';
import { HiresourceComponent } from './components/hiresource/hiresource.component';
import { SalutionComponent } from './components/salution/salution.component';
import { AddhiresourceComponent } from './components/hiresource/addhiresource/addhiresource.component';
import { AddsalutionComponent } from './components/salution/addsalution/addsalution.component';
import { DoctypeComponent } from './components/doctype/doctype.component';
import { AdddoctypeComponent } from './components/doctype/adddoctype/adddoctype.component';
import { EmpdocumentComponent } from './components/empdocument/empdocument.component';
import { EmpassetComponent } from './components/empasset/empasset.component';
import { EmpskillsComponent } from './components/empskills/empskills.component';
import { DisablecontrolDirective } from './disablecontrol.directive';
import { TestmComponent } from './testm/testm.component';
import { BonusComponent } from './components/bonus/bonus.component';
import { AddBonusComponent } from './components/bonus/addbonus/addbonus.component';
import { ReimburseComponent } from './components/reimburse/reimburse.component';
import { AddreimburseComponent } from './components/reimburse/addreimburse/addreimburse.component';
import { MemoComponent } from './components/memo/memo.component';
import { AddmemoComponent } from './components/memo/addmemo/addmemo.component';
import { ActionformatterComponent } from './components/grid/actionformatter/actionformatter.component';

import { AddempnewComponent } from './components/emp/addempnew/addempnew.component';
import { AddempviewComponent } from './components/emp/addempview/addempview.component';
import { AddemppopComponent } from './components/emp/addemppop/addemppop.component';


import { TrainingComponent } from './components/training/training.component';
import { AddtrainingComponent } from './components/training/addtraining/addtraining.component';
import { PayadvComponent } from './components/payadv/payadv.component';
import { AddpayadvComponent } from './components/payadv/addpayadv/addpayadv.component';
import { TransferComponent } from './components/transfer/transfer.component';
import { AddtransferComponent } from './components/transfer/addtransfer/addtransfer.component';
import { OvertimeComponent } from './components/overtime/overtime.component';
import { AddovertimeComponent } from './components/overtime/addovertime/addovertime.component';
import { LoanComponent } from './components/loan/loan.component';
import { AddloanComponent } from './components/loan/addloan/addloan.component';
import { PayrollComponent } from './components/payroll/payroll.component';
import { AddpayrollComponent } from './components/payroll/addpayroll/addpayroll.component';
import { EditpayrolldetComponent } from './components/payroll/editpayrolldet/editpayrolldet.component';
import { PayslipComponent } from './components/payroll/payslip/payslip.component';
import { FilterComponent } from './components/grid/filter/filter.component';
import { FilterlistComponent } from './components/grid/filterlist/filterlist.component';
import { DocumentComponent } from './components/document/document.component';
import { AdddocumentComponent } from './components/document/adddocument/adddocument.component';
import { AdddocumentdetailsComponent } from './components/document/adddocumentdetails/adddocumentdetails.component';
import { DocumentviewerComponent } from './components/document/documentviewer/documentviewer.component';
import { AnnualleaveComponent } from './components/annualleave/annualleave.component';
import { AddannualleaveComponent } from './components/annualleave/addannualleave/addannualleave.component';

import { AddloandetailsComponent } from './components/loan/addloandetails/addloandetails.component';
import { LeavesalaryComponent } from './components/leavesalary/leavesalary.component';
import { AddleavesalaryComponent } from './components/leavesalary/addleavesalary/addleavesalary.component';
import { ViewpayrolldetComponent } from './components/payroll/viewpayrolldet/viewpayrolldet.component';
import { ApprovalsComponent } from './components/approvals/approvals.component';

import { PayadjComponent } from './components/payadj/payadj.component';
import { AddpayadjComponent } from './components/payadj/addpayadj/addpayadj.component';

import { ApprovesiderComponent } from './components/grid/approvesider/approvesider.component';

import { ReportsComponent } from './components/reports/reports.component';
import { ReportmenusliderComponent } from './components/reportmenuslider/reportmenuslider.component';
import { ReportsummaryComponent } from './components/reports/reportsummary/reportsummary.component';
import { ReportfilterComponent } from './components/grid/reportfilter/reportfilter.component';
import { AddleavepolicydetailComponent } from './components/leavepolicy/addleavepolicydetail/addleavepolicydetail.component';
import { BankbranchComponent } from './components/bankbranch/bankbranch.component';
import { AddbankbranchComponent } from './components/bankbranch/addbankbranch/addbankbranch.component';
import { DatetimeFormatPipe } from './datetime-format.pipe';
import { AlerttypeComponent } from './components/alerttype/alerttype.component';
import { AddalerttypeComponent } from './components/alerttype/addalerttype/addalerttype.component';
import { AddpayadjdetailComponent } from './components/payadj/addpayadjdetail/addpayadjdetail.component';
import { ProcessComponent } from './components/grid/process/process.component';
import { SettingsComponent } from './components/settings/settings.component';
import { UseraccessComponent } from './components/grid/useraccess/useraccess.component';
import { LoadingComponent } from './components/grid/loading/loading.component';
import { AttachmentComponent } from './components/grid/attachment/attachment.component';
import { ActivityfooterComponent } from './components/grid/activityfooter/activityfooter.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { AddcurrencyComponent } from './components/currency/addcurrency/addcurrency.component';
import { ExpensepolicyComponent } from './components/expensepolicy/expensepolicy.component';
import { AddexpensepolicyComponent } from './components/expensepolicy/addexpensepolicy/addexpensepolicy.component';
import { AddexpensepolicydetailsComponent } from './components/expensepolicy/addexpensepolicydetails/addexpensepolicydetails.component';
import { ScheduletemplateComponent } from './components/scheduletemplate/scheduletemplate.component';
import { AddscheduletemplateComponent } from './components/scheduletemplate/addscheduletemplate/addscheduletemplate.component';
import { SchedulecheckboxComponent } from './components/grid/schedulecheckbox/schedulecheckbox.component';
import { ImportemployeeComponent } from './components/emp/importemployee/importemployee.component';
import { ImportovertimeComponent } from './components/overtime/importovertime/importovertime.component';
import { PtaxmainComponent } from './components/ptaxmain/ptaxmain.component';
import { AddptaxmainComponent } from './components/ptaxmain/addptaxmain/addptaxmain.component';
import { AddptaxmaindetailsComponent } from './components/ptaxmain/addptaxmaindetails/addptaxmaindetails.component';
import { PayrollcheckComponent } from './components/payroll/payrollcheck/payrollcheck.component';
import { CommentsComponent } from './components/grid/comments/comments.component';
import { ReportemployeesummaryComponent } from './components/reports/reportemployeesummary/reportemployeesummary.component';
import { AddbankbranchpopupComponent } from './components/generalpopup/addbankbranchpopup/addbankbranchpopup.component';
import { AddloantypepopupComponent } from './components/generalpopup/addloantypepopup/addloantypepopup.component';
import { AddbonustypepopupComponent } from './components/generalpopup/addbonustypepopup/addbonustypepopup.component';
import { AddexpensetypepopupComponent } from './components/generalpopup/addexpensetypepopup/addexpensetypepopup.component';
import { AddreimbursetypepopupComponent } from './components/generalpopup/addreimbursetypepopup/addreimbursetypepopup.component';
import { AddincidenttypepopupComponent } from './components/generalpopup/addincidenttypepopup/addincidenttypepopup.component';
import { AddmemotypepopupComponent } from './components/generalpopup/addmemotypepopup/addmemotypepopup.component';
import { AddleavetypepopupComponent } from './components/generalpopup/addleavetypepopup/addleavetypepopup.component';
import { AddovertimetypepopupComponent } from './components/generalpopup/addovertimetypepopup/addovertimetypepopup.component';
import { AddassettypepopupComponent } from './components/generalpopup/addassettypepopup/addassettypepopup.component';
import { AddlocationpopupComponent } from './components/generalpopup/addlocationpopup/addlocationpopup.component';
import { AddbranchpopupComponent } from './components/generalpopup/addbranchpopup/addbranchpopup.component';
import { ActivitylogreportComponent } from './components/reports/activitylogreport/activitylogreport.component';
import { ApprovepopComponent } from './components/grid/approvepop/approvepop.component';
import { TransstatusbarComponent } from './components/grid/transstatusbar/transstatusbar.component';
import { FilterpopupComponent } from './components/grid/filterpopup/filterpopup.component';
import { LeavereportComponent } from './components/reports/leavereport/leavereport.component';
import { AssetreportComponent } from './components/reports/assetreport/assetreport.component';
import { TrainingreportComponent } from './components/reports/trainingreport/trainingreport.component';
import { OvertimereportComponent } from './components/reports/overtimereport/overtimereport.component';
import { PayrollsummaryreportComponent } from './components/reports/payrollsummaryreport/payrollsummaryreport.component';
import { EmployeepayreportComponent } from './components/reports/employeepayreport/employeepayreport.component';
import { PayadvreportComponent } from './components/reports/payadvreport/payadvreport.component';
import { NavigationmenuComponent } from './components/navigationmenu/navigationmenu.component';
import { AddpaymodepopupComponent } from './components/generalpopup/addpaymodepopup/addpaymodepopup.component';
import { AddpayrolegrppopupComponent } from './components/generalpopup/addpayrolegrppopup/addpayrolegrppopup.component';
import { AddpaytypepopupComponent } from './components/generalpopup/addpaytypepopup/addpaytypepopup.component';
import { AddwpsgrouppopupComponent } from './components/generalpopup/addwpsgrouppopup/addwpsgrouppopup.component';
import { AddallowancepopupComponent } from './components/generalpopup/addallowancepopup/addallowancepopup.component';
import { AddhiresourcepopupComponent } from './components/generalpopup/addhiresourcepopup/addhiresourcepopup.component';
import { AddemptypepopupComponent } from './components/generalpopup/addemptypepopup/addemptypepopup.component';
import { AddcontracttypepopupComponent } from './components/generalpopup/addcontracttypepopup/addcontracttypepopup.component';
import { AddcategorypopupComponent } from './components/generalpopup/addcategorypopup/addcategorypopup.component';
import { AdddepartmentpopupComponent } from './components/generalpopup/adddepartmentpopup/adddepartmentpopup.component';
import { AdddesignationpopupComponent } from './components/generalpopup/adddesignationpopup/adddesignationpopup.component';
import { AddgradepopupComponent } from './components/generalpopup/addgradepopup/addgradepopup.component';
import { AddsponserpopupComponent } from './components/generalpopup/addsponserpopup/addsponserpopup.component';
import { AddaccomtypepopupComponent } from './components/generalpopup/addaccomtypepopup/addaccomtypepopup.component';
import { AdddeductionpopupComponent } from './components/generalpopup/adddeductionpopup/adddeductionpopup.component';
import { AdddoctypepopupComponent } from './components/generalpopup/adddoctypepopup/adddoctypepopup.component';
import { AddskillspopupComponent } from './components/generalpopup/addskillspopup/addskillspopup.component';
import { AddassetpopupComponent } from './components/generalpopup/addassetpopup/addassetpopup.component';
import { TranspaymodeComponent } from './components/transpaymode/transpaymode.component';
import { AddtranspaymodeComponent } from './components/transpaymode/addtranspaymode/addtranspaymode.component';
import { FinetypeComponent } from './components/finetype/finetype.component';
import { AddfinetypeComponent } from './components/finetype/addfinetype/addfinetype.component';
import { FineComponent } from './components/fine/fine.component';
import { AddfineComponent } from './components/fine/addfine/addfine.component';
import { AddfinetypepopupComponent } from './components/generalpopup/addfinetypepopup/addfinetypepopup.component';
import { PromotionComponent } from './components/promotion/promotion.component';
import { AddpromotionComponent } from './components/promotion/addpromotion/addpromotion.component';
import { EmpfilterComponent } from './components/grid/empfilter/empfilter.component';
import { EmptystageComponent } from './emptystage/emptystage.component';
import { TranspaymentinfoComponent } from './components/grid/transpaymentinfo/transpaymentinfo.component';
import { LoanpauseComponent } from './components/loan/loanpause/loanpause.component';
import {AutofocusDirective} from './auto-focus.directive';
import { DocumentexpiryreportComponent } from './components/documentexpiryreport/documentexpiryreport.component';
import { EmployeesalaryreportComponent } from './components/employeesalaryreport/employeesalaryreport.component';
import { LoansummaryreportComponent } from './components/reports/loansummaryreport/loansummaryreport.component';
import { LoanoutstandingsummaryreportComponent } from './components/reports/loanoutstandingsummaryreport/loanoutstandingsummaryreport.component';
import { EmpfilterlistComponent } from './components/grid/empfilterlist/empfilterlist.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarviewComponent } from './components/grid/calendarview/calendarview.component';
import { RequesttypeComponent } from './components/requesttype/requesttype.component';
import { AddrequesttypeComponent } from './components/requesttype/addrequesttype/addrequesttype.component';
import { OtherrequestComponent } from './components/otherrequest/otherrequest.component';
import { AddotherrequestComponent } from './components/otherrequest/addotherrequest/addotherrequest.component';
import { AddrequesttypepopupComponent } from './components/generalpopup/addrequesttypepopup/addrequesttypepopup.component';
import { ShorttermpayComponent } from './components/shorttermpay/shorttermpay.component';
import { AddshorttermpayComponent } from './components/shorttermpay/addshorttermpay/addshorttermpay.component';
import { ShorttermpaydetailsComponent } from './components/shorttermpay/shorttermpaydetails/shorttermpaydetails.component';
import { DateMonthFormatPipe } from './datemonth-format.pipe';
import { AddtranspaymodepopupComponent } from './components/generalpopup/addtranspaymodepopup/addtranspaymodepopup.component';
import { EmpdetailschangeComponent } from './components/empdetailschange/empdetailschange.component';
import { AddempdetailschangeComponent } from './components/empdetailschange/addempdetailschange/addempdetailschange.component';
import { InsurancetypeComponent } from './components/insurancetype/insurancetype.component';
import { AddinsurancetypeComponent } from './components/insurancetype/addinsurancetype/addinsurancetype.component';
import { InsurancecompanyComponent } from './components/insurancecompany/insurancecompany.component';
import { AddinsurancecompanyComponent } from './components/insurancecompany/addinsurancecompany/addinsurancecompany.component';
import { ReasonComponent } from './components/reason/reason.component';
import { AddreasonComponent } from './components/reason/addreason/addreason.component';
import { InsuranceComponent } from './components/insurance/insurance.component';
import { AddinsurancepopupComponent } from './components/insurance/addinsurancepopup/addinsurancepopup.component';
import { AddinsurancetypepopupComponent } from './components/generalpopup/addinsurancetypepopup/addinsurancetypepopup.component';
import { AddinsurancecompanypopupComponent } from './components/generalpopup/addinsurancecompanypopup/addinsurancecompanypopup.component';
import { AirticketComponent } from './components/airticket/airticket.component';
import { AddairticketComponent } from './components/airticket/addairticket/addairticket.component';
import { LeaveoptionpopupComponent } from './components/leave/leaveoptionpopup/leaveoptionpopup.component';
import { InsurancereportComponent } from './components/reports/insurancereport/insurancereport.component';
import { FinalsettlementComponent } from './components/finalsettlement/finalsettlement.component';
import { AddfinalsettlementComponent } from './components/finalsettlement/addfinalsettlement/addfinalsettlement.component';
import { ActivitypopupComponent } from './components/grid/activitypopup/activitypopup.component';
import { CancelleavepopupComponent } from './components/leave/cancelleavepopup/cancelleavepopup.component';
import { AttendancereportComponent } from './components/reports/attendancereport/attendancereport.component';
import { AttendanceComponent } from './components/attendance/attendance.component';
import { AttendancesummaryreportComponent } from './components/reports/attendancesummaryreport/attendancesummaryreport.component';
import { RenogridComponent } from './components/grid/renogrid/renogrid.component';
import { SortDirective } from './sort.directive';
import { SessionoutComponent } from './components/grid/sessionout/sessionout.component';
import { ExportgridComponent } from './components/grid/exportgrid/exportgrid.component';
import { DemoregistrationComponent } from './components/demoregistration/demoregistration.component';
import { EmpreqdetailsreportComponent } from './components/reports/empreqdetailsreport/empreqdetailsreport.component';
import { EmppersonalreportComponent } from './components/reports/emppersonalreport/emppersonalreport.component';
import { HeadcountreportComponent } from './components/reports/headcountreport/headcountreport.component';
import { FinalsettlementreportComponent } from './components/reports/finalsettlementreport/finalsettlementreport.component';
import { HolidaysreportComponent } from './components/reports/holidaysreport/holidaysreport.component';
import { InoutpunchdetailsreportComponent } from './components/reports/inoutpunchdetailsreport/inoutpunchdetailsreport.component';
import { InoutpunchreportComponent } from './components/reports/inoutpunchreport/inoutpunchreport.component';
import { PaymentlistviewreportComponent } from './components/reports/paymentlistviewreport/paymentlistviewreport.component';
import { EmpfindComponent } from './components/empfind/empfind.component';
import { BulkbonusComponent } from './components/bonus/bulkbonus/bulkbonus.component';
import { AddbulkempdetailschangeComponent } from './components/empdetailschange/addbulkempdetailschange/addbulkempdetailschange.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  decimal: ".",
  precision: 2,
  prefix: " ",
  suffix: "",
  thousands: ""
};




@NgModule({
  declarations: [
    AppComponent,
    DepartmentComponent,
    NavigationComponent,
    HeaderComponent,
    DashboardComponent,
    ConfirmationDialogComponent,
    AdddepartmentComponent,
    TestComponent,
    CompanyComponent,
    BranchComponent,
    AllowanceComponent,
    AssettypeComponent,
    BonustypeComponent,
    AddbonustypeComponent,
    AddassettypeComponent,
    AddallowanceComponent,
    AddbranchComponent,
    AddcompanyComponent,
    DeductionComponent,
    DesignationComponent,
    EmptypeComponent,
    ExpensetypeComponent,
    GenderComponent,
    GradeComponent,
    AdddeductionComponent,
    AdddesignationComponent,
    AddemptypeComponent,
    AddexpensetypeComponent,
    AddgenderComponent,
    AddgradeComponent,
    IncidenttypeComponent,
    LeavetypeComponent,
    LoantypeComponent,
    LocationComponent,
    MaritalstatusComponent,
    MemotypeComponent,
    AddmemotypeComponent,
    AddmaritalstatusComponent,
    AddlocationComponent,
    AddloantypeComponent,
    AddleavetypeComponent,
    AddincidenttypeComponent,
    OvertimetypeComponent,
    AddovertimetypeComponent,
    PaymodeComponent,
    AddpaymodeComponent,
    PayrolegrpComponent,
    AddpayrolegrpComponent,
    ReimbursetypeComponent,
    AddreimbursetypeComponent,
    RelationshipComponent,
    AddrelationshipComponent,
    RelievetypeComponent,
    AddrelievetypeComponent,
    SkillsComponent,
    AddskillsComponent,
    UserroleComponent,
    UserComponent,
    AssetComponent,
    HolidaysComponent,
    AdduserroleComponent,
    AdduserComponent,
    AddassetComponent,
    AddholidaysComponent,
    EmpComponent,
    AddempComponent,
    ExpenseComponent,
    AddexpenseComponent,
    DateFormatPipe,
    DateMonthFormatPipe,
    LeaveComponent,
    AddleaveComponent,
    IncidentComponent,
    AddincidentComponent,
    LoginComponent,
    ReligionComponent,
    SponserComponent,
    ContracttypeComponent,
    CategoryComponent,
    AddreligionComponent,
    AddsponserComponent,
    AddcontracttypeComponent,
    AddcategoryComponent,
    PaytypeComponent,
    WpsgroupComponent,
    BankComponent,
    AddbankComponent,
    AddwpsgroupComponent,
    AddpaytypeComponent,
    StatusComponent,
    AddstatusComponent,
    LeavepolicyComponent,
    AddleavepolicyComponent,
    AccomtypeComponent,
    AddaccomtypeComponent,
    EmppayComponent,
    HiresourceComponent,
    SalutionComponent,
    AddhiresourceComponent,
    AddsalutionComponent,
    DoctypeComponent,
    AdddoctypeComponent,
    EmpdocumentComponent,
    EmpassetComponent,
    EmpskillsComponent,
    DisablecontrolDirective,
    TestmComponent,
    BonusComponent,
    AddBonusComponent,
    ReimburseComponent,
    AddreimburseComponent,
    MemoComponent,
    AddmemoComponent,
    ActionformatterComponent,
    AddempnewComponent,
    AddempviewComponent,
    AddemppopComponent,
    TrainingComponent,
    AddtrainingComponent,
    PayadvComponent,
    AddpayadvComponent,
    TransferComponent,
    AddtransferComponent,
    OvertimeComponent,
    AddovertimeComponent,
    LoanComponent,
    AddloanComponent,
    PayrollComponent,
    AddpayrollComponent,
    EditpayrolldetComponent,
    PayslipComponent,
    FilterComponent,
    FilterlistComponent,
    DocumentComponent,
    AdddocumentComponent,
    AdddocumentdetailsComponent,
    DocumentviewerComponent,
    AnnualleaveComponent,
    AddannualleaveComponent,
    AddloandetailsComponent,
    LeavesalaryComponent,
    AddleavesalaryComponent,
    ViewpayrolldetComponent,
    ApprovalsComponent,
    PayadjComponent,
    AddpayadjComponent,
    ApprovesiderComponent,
    ReportsComponent,
    ReportmenusliderComponent,
    ReportsummaryComponent,
    ReportfilterComponent,
    AddleavepolicydetailComponent,
    BankbranchComponent,
    AddbankbranchComponent,
    DatetimeFormatPipe,
    AlerttypeComponent,
    AddalerttypeComponent,
    AddpayadjdetailComponent,
    ProcessComponent,
    SettingsComponent,
    UseraccessComponent,
    LoadingComponent,
    AttachmentComponent,
    ActivityfooterComponent,
    CurrencyComponent,
    AddcurrencyComponent,
    ExpensepolicyComponent,
    AddexpensepolicyComponent,
    AddexpensepolicydetailsComponent,
    ScheduletemplateComponent,
    AddscheduletemplateComponent,
    SchedulecheckboxComponent,
    ImportemployeeComponent,
    ImportovertimeComponent,
    PtaxmainComponent,
    AddptaxmainComponent,
    AddptaxmaindetailsComponent,
    PayrollcheckComponent,
    CommentsComponent,
    ReportemployeesummaryComponent,
    AddbankbranchpopupComponent,
    AddloantypepopupComponent,
    AddbonustypepopupComponent,
    AddexpensetypepopupComponent,
    AddreimbursetypepopupComponent,
    AddincidenttypepopupComponent,
    AddmemotypepopupComponent,
    AddleavetypepopupComponent,
    AddovertimetypepopupComponent,
    AddassettypepopupComponent,
    AddlocationpopupComponent,
    AddbranchpopupComponent,
    ActivitylogreportComponent,
    ApprovepopComponent,
    TransstatusbarComponent,
    FilterpopupComponent,
    LeavereportComponent,
    AssetreportComponent,
    TrainingreportComponent,
    OvertimereportComponent,
    PayrollsummaryreportComponent,
    EmployeepayreportComponent,
    PayadvreportComponent,
    NavigationmenuComponent,
    AddpaymodepopupComponent,
    AddpayrolegrppopupComponent,
    AddpaytypepopupComponent,
    AddwpsgrouppopupComponent,
    AddallowancepopupComponent,
    AddhiresourcepopupComponent,
    AddemptypepopupComponent,
    AddcontracttypepopupComponent,
    AddcategorypopupComponent,
    AdddepartmentpopupComponent,
    AdddesignationpopupComponent,
    AddgradepopupComponent,
    AddsponserpopupComponent,
    AddaccomtypepopupComponent,
    AdddeductionpopupComponent,
    AdddoctypepopupComponent,
    AddskillspopupComponent,
    AddassetpopupComponent,
    TranspaymodeComponent,
    AddtranspaymodeComponent,
    FinetypeComponent,
    AddfinetypeComponent,
    FineComponent,
    AddfineComponent,
    AddfinetypepopupComponent,
    PromotionComponent,
    AddpromotionComponent,
    EmpfilterComponent,
    EmptystageComponent,
    TranspaymentinfoComponent,
    LoanpauseComponent,
    AutofocusDirective,
    DocumentexpiryreportComponent,
    EmployeesalaryreportComponent,
    LoansummaryreportComponent,
    LoanoutstandingsummaryreportComponent,
    EmpfilterlistComponent,
    CalendarviewComponent,
    RequesttypeComponent,
    AddrequesttypeComponent,
    OtherrequestComponent,
    AddotherrequestComponent,
    AddrequesttypepopupComponent,
    ShorttermpayComponent,
    AddshorttermpayComponent,
    ShorttermpaydetailsComponent,
    AddtranspaymodepopupComponent,
    EmpdetailschangeComponent,
    AddempdetailschangeComponent,
    InsurancetypeComponent,
    AddinsurancetypeComponent,
    InsurancecompanyComponent,
    AddinsurancecompanyComponent,
    ReasonComponent,
    AddreasonComponent,
    InsuranceComponent,
    AddinsurancepopupComponent,
    AddinsurancetypepopupComponent,
    AddinsurancecompanypopupComponent,
    AirticketComponent,
    AddairticketComponent,
    LeaveoptionpopupComponent,
    InsurancereportComponent,
    FinalsettlementComponent,
    AddfinalsettlementComponent,
    ActivitypopupComponent,
    CancelleavepopupComponent,
    AttendancereportComponent,
    AttendanceComponent,
    AttendancesummaryreportComponent,
    RenogridComponent,
    SortDirective,
    SessionoutComponent,
    ExportgridComponent,
    DemoregistrationComponent,
    EmpreqdetailsreportComponent,
    EmppersonalreportComponent,
    HeadcountreportComponent,
    FinalsettlementreportComponent,
    HolidaysreportComponent,
    InoutpunchdetailsreportComponent,
    InoutpunchreportComponent,
    PaymentlistviewreportComponent,
    EmpfindComponent,
    BulkbonusComponent,
    AddbulkempdetailschangeComponent
  ],
  imports: [
    
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgProgressModule,
    NgProgressHttpModule,
    NgProgressRouterModule,
    DataTablesModule,
    NgSelectModule,
    MatInputModule,
    MatFormFieldModule,
    SidebarModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxMaskModule.forRoot(),
    PdfViewerModule,
    NgxPaginationModule,
    ToastrModule.forRoot({
      timeOut: 500,
      positionClass: 'toast-top-center'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    Ng2SearchPipeModule,
    AgGridModule.withComponents([]),
    CurrencyMaskModule,
    NgxDocViewerModule,
    AutocompleteLibModule,
    DeviceDetectorModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [DatePipe, DateFormatPipe,DateMonthFormatPipe, PendingChangesGuard, Location, BnNgIdleService, { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }],
  bootstrap: [AppComponent],
  exports: [BrowserModule, TranslateModule],
  entryComponents: [ConfirmationDialogComponent, EmppayComponent, EmpdocumentComponent, EmpassetComponent, EmpskillsComponent,
    AddemppopComponent, EditpayrolldetComponent, PayslipComponent, AdddocumentComponent, AdddocumentdetailsComponent, DocumentviewerComponent, AddloandetailsComponent,
    AddleavepolicydetailComponent, AddpayadjdetailComponent, AddexpensepolicydetailsComponent, ImportemployeeComponent, ImportovertimeComponent, AddptaxmaindetailsComponent,
    PayrollcheckComponent, AddloantypepopupComponent, AddbonustypepopupComponent, AddexpensetypepopupComponent, AddreimbursetypepopupComponent, AddincidenttypepopupComponent,
    AddmemotypepopupComponent, AddleavetypepopupComponent, AddovertimetypepopupComponent, AddassettypepopupComponent, AddlocationpopupComponent, AddbranchpopupComponent,
    ApprovepopComponent, FilterpopupComponent, AddpaymodepopupComponent, AddpayrolegrppopupComponent, AddpaytypepopupComponent, AddwpsgrouppopupComponent, AddbankbranchpopupComponent,
    AddhiresourcepopupComponent, AddemptypepopupComponent, AddcontracttypepopupComponent, AddcategorypopupComponent, AdddepartmentpopupComponent, AdddesignationpopupComponent,
    AddgradepopupComponent, AddsponserpopupComponent, AddsponserpopupComponent, AddaccomtypepopupComponent, AddallowancepopupComponent, AdddeductionpopupComponent,
    AdddoctypepopupComponent, AddskillspopupComponent, AddassetpopupComponent, AddfinetypepopupComponent, EmpfilterComponent, TranspaymentinfoComponent, LoanpauseComponent,
    AttachmentComponent,ReportfilterComponent,EmpfilterlistComponent,AddrequesttypepopupComponent,ShorttermpaydetailsComponent,AddtranspaymodepopupComponent,AddinsurancepopupComponent,
    AddinsurancetypepopupComponent,AddinsurancecompanypopupComponent,LeaveoptionpopupComponent,ActivitypopupComponent,CancelleavepopupComponent,SessionoutComponent,ExportgridComponent,
    DemoregistrationComponent,EmpfindComponent     

  ],
})
export class AppModule { }
